module.exports = __webpack_public_path__ + "img/about.d810d935.jpg";